<template>
    <div>
        <base-header type="gray-100" class="pb-6 pb-8 pt-5 pt-md-5">
        </base-header>

        <div class="container-fluid mt--7">
            <div class="row">
                <div class="col">
                    <div class="card shadow">
                      <div class="card-header border-0">
                        <div class="row align-items-center">
                          <div class="col head">
                            <h3 class="mb-0">
                              Assinaturas
                            </h3>

                            <!--<base-button size="sm" class="clickable" @click="goCsv()">Exportar</base-button>-->
                          </div>
                        </div>
                      </div>

                      <template v-if="loading">
                          <div class="m-2">
                            <skeleton altura="60px" :velocidade="2.2" :atraso="0.2" :itens="1" classItem="mb-2"></skeleton>
                          </div>
                        </template>


                      <!-- Card stats -->
                      <div class="row" v-if="!loading" style="padding: 20px 20px 40px 20px;">
                          <div class="col-xl-4 col-lg-4">
                              <stats-card title="Ativos"
                                          type="gradient-primary"
                                          v-bind:sub-title="facets.planoAtivo || '0'"
                                          icon="fas fa-check"
                                          class="mb-4 mb-xl-0"
                              >

                                  <template slot="footer">
                                      <span class="text-light">planos ativos.</span>
                                  </template>
                              </stats-card>
                          </div>
                          <div class="col-xl-4 col-lg-4">
                              <stats-card title="Inativos"
                                          type="gradient-primary"
                                          v-bind:sub-title="facets.planoInativo || '0'"
                                          icon="fas fa-times"
                                          class="mb-4 mb-xl-0"
                              >

                                  <template slot="footer">
                                      <span class="text-light">planos inativos.</span>
                                  </template>
                              </stats-card>
                          </div>

                          <div class="col-xl-4 col-lg-4">
                              <stats-card title="Previsões"
                                          type="gradient-primary"
                                          v-bind:sub-title="facets.renovacoesPrevistas || '0'"
                                          icon="fas fa-award"
                                          class="mb-4 mb-xl-0"
                              >

                                  <template slot="footer">
                                      <span class="text-light">renovações previstas.</span>
                                  </template>
                              </stats-card>
                          </div>
                      </div>
                      
                      <div class="d-flex column px-3 mb-4">
                        <base-button class="align-self-start" :disabled="aplicandoFiltros" :icon="aplicandoFiltros ? 'fas fa-circle-notch fa-spin' : filtrosAlterados ? 'fas fa-check' : 'fas fa-filter'" size="sm" :type="filtrosAlterados ? 'info' : 'default'" :outline="!filtroAberto && !aplicandoFiltros" @click="aplicarFiltros()">{{filtrosAlterados ? 'Aplicar filtros' : 'Filtros'}}</base-button>
                        <div class="row filtros px-2 mt-3" v-show="filtroAberto">

                          <base-input class="mr-2 flex-grow-1" type="text" placeholder="nome" v-model="filtros.nome"></base-input>

                          <base-input class="mr-2 flex-grow-1">
                            <multiselect
                              v-model="filtros.status"
                              track-by="valor"
                              label="nome"
                              :options="status"
                              placeholder="por status"
                              :multiple="true"
                              selectLabel="Selecionar"
                              selectedLabel="✔"
                              deselectLabel="Limpar"
                            >
                              <span slot="noResult">Todos os status</span>
                            </multiselect>
                          </base-input>
                        </div>
                        <base-button size="sm" v-if="filtroAberto" class="limpar mt-2 align-self-end clickable small" outline @click="limparFiltros()">Limpar filtros</base-button>
                      </div>

                      <div class="table-responsive">
                        <template>
                          <base-table class="table align-items-center table-flush"
                                      tbody-classes="list"
                                      :data="assinaturasList">
                            <template slot="columns">
                              <th class="text-center">Plano</th>
                              <th>Valor</th>
                              <th>Nome Completo / Razão Social</th>
                              <th>E-mail</th>
                              <th>Último Pagamento</th>
                              <th>Próximo Pagamento</th>
                              <th class="text-center">Haverá Renovação</th>
                              <th class="text-center">Status</th>
                             
                            </template>

                            <template slot-scope="{row}" v-if="!loading">
                              <th scope="row"  class="text-center">
                                <badge class="mr-4" :type="setTipo(row.tipo, 'color')">
                                  {{setTipo(row.tipo, 'label')}}
                                </badge>
                              </th>
                               <td>
                                R$ {{ (row.ultimo_valor_pago / 100).toLocaleString('pt-br', {minimumFractionDigits: 2}) }}
                              </td>
                              <td>
                                {{ row.nomeFantasia || row.nome }}
                              </td>
                                <td>
                                {{ row.email }}
                              </td>
                              <td>
                                <span class="name mb-0 text-sm"> {{formatarData(row.ultimo_pagamento)}}</span>
                              </td>
                              <td>
                                <span class="name mb-0 text-sm"> {{formatarData(row.proximo_pagamento)}}</span>
                              </td>
                              <td class="text-center">
                                <badge class="mr-4" :type="setRenovacao(row.ira_renovar, 'color')">
                                  {{setRenovacao(row.ira_renovar, 'label')}}
                                </badge>
                              </td>
                              <td class="text-center">
                                <badge class="mr-4" :type="setStatus(row.ativo, 'color')">
                                  {{setStatus(row.ativo, 'label')}}
                                </badge>
                              </td>
                           

                            </template>

                          </base-table>
                        </template>
                      </div>

                       <div class="card-footer d-flex justify-content-center" v-if="!loading">
                        <span class="text-size-xl cursor" @click="loadMore()">
                          <i class="fas fa-chevron-circle-down"></i>
                        </span>
                      </div>

                    </div>
                </div>
            </div>
        </div>

    </div>
</template>
<script>
  import assinaturas from '@/cflow/assinaturas.js'
  //import parametros from "@/cflow/parametros.js";
  import BaseButton from '../../components/BaseButton.vue';
  import BaseInput from '../../components/BaseInput.vue';
  import Multiselect from "vue-multiselect";
  import storage from 'storage';
  import config from 'config';
  export default {
    name: 'tables',
    components: {
      Multiselect,
      BaseButton,
      BaseInput
    },
    methods: {
      goCsv: function() {

          const api = config[process.env.NODE_ENV].api.endpoint;
          const csv = `${api}/csv/usuarios`;
          window.location = csv;

      },
        setTipo: function(tipo, flag) {
          if(flag == 'color' && tipo != 'lab' && tipo != 'den') {
             return 'secondary';
          }
           if(flag == 'label' && tipo != 'lab' && tipo != 'den') {
             return 'Não Informado';
          }
        let tiposList;
        if(flag == 'color') tiposList = { 'lab' : 'default', 'den' : 'info'};
        if(flag == 'label') tiposList = { 'lab' : 'Laboratório', 'den' : 'Dentista'};
       for (let key in tiposList) {
            if(tipo == key) {
                return tiposList[key];
            }
        }
      },
      setStatus: function(status, flag) {
        let statusList;
        if(flag == 'color') statusList = { '0' : 'warning', '1' : 'success'};
        if(flag == 'label') statusList = { '0' : 'Inativo', '1' : 'Ativo'};
       for (let key in statusList) {
            if(status == key) {
                return statusList[key];
            }
        }
      },
      setRenovacao: function(status, flag) {
        let statusList;
        if(flag == 'color') statusList = { '0' : 'warning', '1' : 'success'};
        if(flag == 'label') statusList = { '0' : 'Não', '1' : 'Sim'};
       for (let key in statusList) {
            if(status == key) {
                return statusList[key];
            }
        }
      },
      aplicarFiltros() {
        this.filtroAberto = !this.filtroAberto
        if(this.filtrosAlterados){
          // se os filtros mudaram, então aplicar eles.
          this.aplicandoFiltros = true;
          this.loading = true;
          assinaturas.listar({filtros: this.filtros}, 0).then(res => {
            this.assinaturasList = res.usuarios;
            this.facets = res.info;
            this.aplicandoFiltros = false;
            this.filtrosAlterados = false;
            this.loading = false;
          }).catch(() => {
            this.aplicandoFiltros = false;
          })
        }
      },
      limparFiltros() {
        this.filtros = {
          numero: null,
          data: null,
          status: null,
          dentista: null,
          paciente: null
        }
      },
      loadMore: function() {
        this.skiped += this.assinaturasList.length;
        this.initLoad(this.skiped);
      },
      initLoad: function() {
        this.loading = true;
        var user = storage.get("user");
        //var labId = 0;
        if(user.tipo && user.tipo == 'lab') {
          //labId = user.id;
        }
        Promise.all([assinaturas.listar([], this.skiped)]).then( res => {
          this.assinaturasList = this.assinaturasList.concat(res[0].usuarios);
          this.facets = res[0].info;
          this.loading = false;
        })
      }
    },
    watch: {
      filtros: {
        deep: true,
        handler(){
          this.filtrosAlterados = true
        }
      }
    },
    data() {
      return {
        loading: false,
        skiped: 0,
        facets: {},
        usuariosList:[],
        assinaturasList:[],
        idxList:[],
        status: [{'nome': 'Ativos', 'valor': 1}, {'nome': 'Inativos', 'valor': 0}],
        coresStatus: ['warning','info','primary','info','info','success','danger','danger'],
        filtrosAlterados: false,
        filtroAberto: false,
        aplicandoFiltros: false,
        filtros: {
            status: null,
            none: null
        },
        opcoesFiltros: {
          dentista: [],
          paciente: [],
        }
      }
    },
    mounted(){
      this.initLoad(0);
    }
  };
</script>
<style lang="scss" scoped>
.filtros .form-group{
  width: 150px;
}
.head {
  display: flex;
  justify-content: space-between;
}
</style>
